module.exports = __webpack_public_path__ + "static/img/pc-web-img-02@w.46eb7e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ipark-duty-free/pc-web-img-02@w.png
// module id = oycF
// module chunks = 0